/**
 * 全局配置文件
 */


// function getPagePath

import Store from '../store/'; // vuex
export default {
  title: 'saber',
  logo: 'S',
  key: 'saber', //配置主键,目前用于存储
  indexTitle: '捷禾ERP',
  clientId: 'saber', // 客户端id
  clientSecret: 'saber_secret', // 客户端密钥
  tenantMode: true, // 是否开启租户模式
  tenantId: '000000', // 管理组租户编号
  captchaMode: true, // 是否开启验证码模式
  lockPage: '/lock',
  tokenTime: 3000,
  tokenHeader: 'Blade-Auth',
  //http的status默认放行列表
  statusWhiteList: [],
  //http的url默认放行列表
  urlWhiteList: [
    '/blade-app-erp/pass/login', // 登录
  ],
  // 请求中不用加cookie白名单
  noCookieList: [
    '/api/teacher/login/'
  ],
  
  //配置首页不可关闭
  isFirstPage: false,
  maxOpenTagList: 10,
  isBaiduStatistics: process.env.VUE_APP_STATISTICS || false,
  
  
 

};



// WEBPACK FOOTER //
// ./src/config/website.js